import { EventEmitter } from './EventEmitter';

export type ToolMode = 'select' | 'hand';

export class ToolModeManager {
    private mode: ToolMode = 'select';
    private readonly emitter = new EventEmitter();

    public getMode(): ToolMode {
        return this.mode;
    }

    public setMode(mode: ToolMode): void {
        if (this.mode === mode) return;
        this.mode = mode;
        this.emitter.emit('modeChanged', mode);
    }

    public on(event: 'modeChanged', callback: (mode: ToolMode) => void): void {
        this.emitter.on(event, callback);
    }
}
